import React, { useState } from 'react';
import Sidebar from '../../components/navigation/Sidebar';
import NotificationCenter from '../../components/navigation/NotificationCenter';
import QuickActionMenu from '../../components/navigation/QuickActionMenu';
import UserManagementTable from '../admin-dashboard/components/UserManagementTable';
import TestModeAuditPanel from '../admin-dashboard/components/TestModeAuditPanel';
import TestAccountApprovalQueue from '../admin-dashboard/components/TestAccountApprovalQueue';
import ExpertApprovalQueue from '../admin-dashboard/components/ExpertApprovalQueue';
import TeamManagement from '../admin-dashboard/components/TeamManagement';
import Icon from '../../components/AppIcon';
import Toaster from '../../components/Toaster';
import TwoFAReminderBanner from '../../components/TwoFAReminderBanner';
import { useAuth } from '../../contexts/AuthContext';
import { useNavigate, useSearchParams } from 'react-router-dom';

const tabs = [
  { id: 'users', label: 'User Management', icon: 'Users' },
  { id: 'experts', label: 'Expert Approvals', icon: 'Shield' },
  { id: 'test-account-approval', label: 'Test Account Approval', icon: 'UserCheck' },
  { id: 'test-mode-audit', label: 'Test Mode Audit', icon: 'Shield' },
  { id: 'team', label: 'Team Management', icon: 'Users' },
];

const AdminUsers = () => {
  const navigate = useNavigate();
  const { signOut } = useAuth();
  const [searchParams] = useSearchParams();
  const [activeTab, setActiveTab] = useState(searchParams.get('tab') || 'users');

  return (
    <div className="min-h-screen bg-background">
      <Toaster position="top-center" />
      <TwoFAReminderBanner />
      <Sidebar userRole="admin" />
      <QuickActionMenu userRole="admin" />
      <div className="lg:ml-60 min-h-screen">
        <header className="sticky top-0 z-40 bg-card border-b border-border">
          <div className="flex items-center justify-between px-4 md:px-6 lg:px-8 py-4">
            <div className="flex items-center gap-4">
              <button
                onClick={() => {
                  const isCollapsed = document.body.classList.toggle('sidebar-collapsed');
                  localStorage.setItem('sidebarCollapsed', isCollapsed.toString());
                }}
                className="p-2 hover:bg-muted rounded-lg transition-colors"
                aria-label="Toggle sidebar"
              >
                <Icon name="PanelLeft" size={24} />
              </button>
              <div>
                <h1 className="text-2xl md:text-3xl font-semibold text-foreground">
                  Users
                </h1>
                <p className="text-sm text-muted-foreground mt-1">
                  User management, approvals &amp; audit
                </p>
              </div>
            </div>
            <div className="flex items-center gap-3">
              <NotificationCenter userRole="admin" />
              <div className="hidden md:flex items-center gap-3 pl-3 border-l border-border">
                <div className="text-right">
                  <p className="text-sm font-medium text-foreground">Admin User</p>
                  <p className="text-xs text-muted-foreground">System Administrator</p>
                </div>
                <div className="w-10 h-10 rounded-full bg-primary flex items-center justify-center">
                  <Icon name="Shield" size={20} color="#FFFFFF" />
                </div>
                <button
                  onClick={async () => { await signOut(); navigate('/login'); }}
                  className="flex items-center gap-2 px-3 py-2 text-sm text-muted-foreground hover:text-foreground border border-border rounded-lg hover:bg-muted transition-colors"
                >
                  <Icon name="LogOut" size={16} />
                  Logout
                </button>
              </div>
            </div>
          </div>
        </header>

        <main className="px-4 md:px-6 lg:px-8 py-6 md:py-8">
          <div className="bg-card border border-border rounded-lg overflow-hidden">
            <div className="border-b border-border overflow-x-auto">
              <div className="flex min-w-max">
                {tabs.map((tab) => (
                  <button
                    key={tab.id}
                    onClick={() => setActiveTab(tab.id)}
                    className={`flex items-center gap-2 px-4 md:px-6 py-4 text-sm font-medium transition-smooth border-b-2 flex-shrink-0 ${
                      activeTab === tab.id
                        ? 'border-primary text-primary bg-primary/5'
                        : 'border-transparent text-muted-foreground hover:text-foreground hover:bg-muted/50'
                    }`}
                  >
                    <Icon name={tab.icon} size={18} />
                    <span>{tab.label}</span>
                  </button>
                ))}
              </div>
            </div>

            <div className="p-4 md:p-6">
              {activeTab === 'users' && <UserManagementTable />}
              {activeTab === 'experts' && <ExpertApprovalQueue />}
              {activeTab === 'test-account-approval' && <TestAccountApprovalQueue />}
              {activeTab === 'test-mode-audit' && <TestModeAuditPanel />}
              {activeTab === 'team' && <TeamManagement />}
            </div>
          </div>
        </main>

        <footer className="border-t border-border mt-12">
          <div className="px-4 md:px-6 lg:px-8 py-6">
            <div className="flex flex-col md:flex-row items-center justify-between gap-4">
              <p className="text-sm text-muted-foreground">
                © {new Date().getFullYear()} FireCaseIQ. All rights reserved.
              </p>
              <div className="flex items-center gap-4">
                <a href="#" className="text-sm text-muted-foreground hover:text-foreground transition-smooth">System Status</a>
                <a href="#" className="text-sm text-muted-foreground hover:text-foreground transition-smooth">Documentation</a>
                <a href="#" className="text-sm text-muted-foreground hover:text-foreground transition-smooth">Support</a>
              </div>
            </div>
          </div>
        </footer>
      </div>
    </div>
  );
};

export default AdminUsers;
